@import "covet-pics-popup-vars.scss";
@import "~swiper/swiper.scss";
@import "~swiper/modules/navigation/navigation.scss";
@import "~swiper/modules/pagination/pagination.scss";

@import "covet-gallery-popup-close-button";
@import "covet-gallery-popup-arrows";
@import "covet-gallery-popup-sharing";
@import "covet-gallery-popup-sidebar";
@import "covet-gallery-popup-carousel";
@import "covet-gallery-popup-hotspots";
@import "covet-gallery-popup-star-rating";


:host {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  visibility: hidden;
  background-color: var(--covet-pics-popup-background-color);
  z-index: 9999999999999;
  font-family: var(--covet-pics-font-family);
  color: #000;
  // TODO check how it works on real sites
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // TODO check how it works on real sites END
}

:host(.covet-pics-popup-show) {
  width: 100%;
  height: 100%;
  visibility: visible;
}

.popup {
  position: absolute;
  visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &.open {
    position: relative;
    visibility: visible;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}

//
// animated popup
//

.animated {
  opacity: 0;
  transition: opacity 0.3s;
  transition-timing-function: ease-in-out;

  .popup-dialog, .upload {
    will-change: top;
    top: 40px;
    transition: top 0.3s;
    transition-timing-function: ease-in-out;
  }
}

:host(.covet-pics-popup-open) {
  .popup.open {
    opacity: 1;

    .popup-dialog, .upload {
      top: 0;
    }
  }
}

//
// popup skeleton
//

.hide {
  display: none !important;
}

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.popup-dialog {
  position: relative;
  max-width: 100%;
  background: #fff;
  margin: 0;
  width: 100%;
  z-index: 1;
}

.post-image {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  &.post-image-carousel {
    display: block;
  }
}

.post-image-element {
  max-width: 100%;
}

.post-video-element {
  max-width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
  max-height: calc(100vh - 20px);

  video {
    object-fit: contain;
    width: 100%;
  }

  .post-video-pause {
    display: none;
  }

  &.playing .post-video-play {
    display: none;
  }

  &.playing .post-video-pause {
    display: block;
  }
}

// TODO temp solution with 2 control buttons in video
.post-video-play {
  border: none;
  outline: none !important;
  position: absolute;
  top: 50%;
  width: 100px;
  height: 100px;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='1585.982 6.353 864 864'%3E%3Cpath opacity='.6' fill='%23231F20' d='M2017.982 6.353c-238.592 0-432 193.409-432 432 0 238.592 193.408 432 432 432 238.591 0 432-193.408 432-432 0-238.591-193.409-432-432-432z'/%3E%3Cpath fill='%23FFF' d='M1910.997 656.622l293.971-219.27-293.971-219.269z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-color: transparent;
  transition: transform 0.25s ease;
  &:hover, &:active, &:focus {
    transform: translate(-50%, -50%) scale(1.1);
  }
}

.post-video-pause {
  border: none;
  outline: none !important;
  position: absolute;
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  transition: transform 0.25s ease;
  background-color: rgba(#23231F20, 0.6);
  border-radius: 50%;
  transition: transform 0.25s ease;
  opacity: 0;
  &::after {
    content: "";
    height: 50%;
    width: 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    background-color: #FFFFFF;
    transform: translate(calc(-100% - 3px), -50%);
  }
  &::before {
    content: "";
    height: 50%;
    width: 4px;
    position: absolute;
    right: 50%;
    top: 50%;
    background-color: #FFFFFF;
    transform: translate(calc(100% + 3px),-50%);
  }
  &:hover, &:active, &:focus {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 1;
  }
}
// TODO temp solution with 2 control buttons in video END

.popup-content {
  display: flex;
  flex-direction: column;
}

.badge {
  align-items: center;
  display: inline-flex;
  box-sizing: border-box;
  border: 0.5px solid $green;
  border-radius: 12px;
  padding: 3px 6px;
  background-color: $green-light;
  margin-left: auto; 
  opacity: 0.8;
}
.badge-text {
  margin-bottom: 0;
  color: $green;
  font-size: 10px;
  margin-top: 0;
  margin-left: 5px;
}

.icon-verified {
  margin-right: 10px;
  &.badge-icon {
    margin-right: 0;
  }
}
.caption {
  margin-top: 20px;
}
.covet-branding {
  position: absolute;
  bottom: -17px;
  left: -14px;
  width: 76px;
  height: 76px;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 38 38' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter x='-61.5%25' y='-61.5%25' width='223.1%25' height='223.1%25' filterUnits='objectBoundingBox' id='a'%3E%3CfeOffset dx='1' dy='2' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeGaussianBlur stdDeviation='3' in='shadowOffsetOuter1' result='shadowBlurOuter1'/%3E%3CfeColorMatrix values='0 0 0 0 0.516785553 0 0 0 0 0.516785553 0 0 0 0 0.516785553 0 0 0 0.4 0' in='shadowBlurOuter1' result='shadowMatrixOuter1'/%3E%3CfeMerge%3E%3CfeMergeNode in='shadowMatrixOuter1'/%3E%3CfeMergeNode in='SourceGraphic'/%3E%3C/feMerge%3E%3C/filter%3E%3C/defs%3E%3Cg filter='url(%23a)' transform='translate(5 4)' fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23212B36' d='M2 2h22v22H2z'/%3E%3Cpath d='M0 1a1 1 0 011-1h24a1 1 0 011 1v24a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm19.668 15.25c-.588 0-1.084.092-1.49.275-.405.183-.708.43-.91.742a1.87 1.87 0 00-.3 1.036c0 .452.113.81.34 1.076.226.265.497.46.813.585.316.124.73.248 1.24.373.364.092.651.173.862.246.21.072.385.171.522.3.137.127.206.289.206.485 0 .269-.123.485-.369.649-.246.164-.618.245-1.116.245a3.59 3.59 0 01-1.201-.21 3.367 3.367 0 01-1.01-.546l-.431.992c.28.25.662.449 1.144.6.482.15.981.226 1.498.226.588 0 1.086-.092 1.494-.276.409-.183.714-.429.915-.736.2-.308.301-.652.301-1.032 0-.445-.113-.799-.34-1.061a2.1 2.1 0 00-.818-.585 8.9 8.9 0 00-1.226-.368 11.399 11.399 0 01-.862-.246 1.477 1.477 0 01-.522-.294.62.62 0 01-.206-.482c0-.281.12-.507.36-.678.239-.17.604-.255 1.096-.255.3 0 .61.046.929.138.32.091.625.226.92.402l.392-.992a3.292 3.292 0 00-1.025-.452 4.695 4.695 0 00-1.206-.157zm-12.79-.191c-.683 0-1.3.152-1.852.457a3.374 3.374 0 00-1.302 1.262 3.516 3.516 0 00-.474 1.818c0 .674.156 1.28.47 1.817a3.34 3.34 0 001.296 1.263c.551.304 1.17.456 1.853.456a3.85 3.85 0 001.524-.294c.461-.197.85-.482 1.166-.855l-.813-.786c-.49.544-1.093.815-1.81.815-.464 0-.88-.103-1.248-.31a2.212 2.212 0 01-.86-.859 2.5 2.5 0 01-.31-1.247c0-.465.103-.881.31-1.248.206-.367.493-.653.86-.86.368-.206.784-.31 1.249-.31.716 0 1.319.27 1.809.806l.813-.776a3.101 3.101 0 00-1.161-.854 3.814 3.814 0 00-1.52-.295zM20.18 3.25h-1.358v6.882h1.358V3.25zm-13.728 0H3.632v6.882h1.273V8.146H6.45c.594 0 1.11-.098 1.551-.295.44-.196.778-.48 1.013-.85.235-.37.353-.805.353-1.303 0-.505-.118-.94-.353-1.307a2.258 2.258 0 00-1.013-.846c-.44-.197-.957-.295-1.55-.295zM6.3 4.397c.567 0 .997.116 1.29.347.294.23.44.561.44.991 0 .43-.146.76-.44.992-.293.231-.723.347-1.29.347H4.78V4.397H6.3z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  transform: scale(0.5);
  z-index: 1;
  outline: none !important;
  &.post-image-carousel {
    margin-bottom: 40px;
  }

  &:hover, &:active, &:focus {
    background-image: url("data:image/svg+xml,%0A%3Csvg viewBox='0 0 38 38' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter x='-61.5%25' y='-61.5%25' width='223.1%25' height='223.1%25' filterUnits='objectBoundingBox' id='a'%3E%3CfeOffset dx='1' dy='2' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeGaussianBlur stdDeviation='3' in='shadowOffsetOuter1' result='shadowBlurOuter1'/%3E%3CfeColorMatrix values='0 0 0 0 0.516785553 0 0 0 0 0.516785553 0 0 0 0 0.516785553 0 0 0 0.4 0' in='shadowBlurOuter1' result='shadowMatrixOuter1'/%3E%3CfeMerge%3E%3CfeMergeNode in='shadowMatrixOuter1'/%3E%3CfeMergeNode in='SourceGraphic'/%3E%3C/feMerge%3E%3C/filter%3E%3C/defs%3E%3Cg filter='url(%23a)' transform='translate(5 4)' fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23EBCC78' d='M2 2h9v9H2z'/%3E%3Cpath fill='%23F7786B' d='M15 2h9v9h-9z'/%3E%3Cpath fill='%2300C5E3' d='M2 15h9v9H2z'/%3E%3Cpath fill='%23ABA0EB' d='M15 15h9v9h-9z'/%3E%3Cpath d='M0 1a1 1 0 011-1h24a1 1 0 011 1v24a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm19.668 15.25c-.588 0-1.084.092-1.49.275-.405.183-.708.43-.91.742a1.87 1.87 0 00-.3 1.036c0 .452.113.81.34 1.076.226.265.497.46.813.585.316.124.73.248 1.24.373.364.092.651.173.862.246.21.072.385.171.522.3.137.127.206.289.206.485 0 .269-.123.485-.369.649-.246.164-.618.245-1.116.245a3.59 3.59 0 01-1.201-.21 3.367 3.367 0 01-1.01-.546l-.431.992c.28.25.662.449 1.144.6.482.15.981.226 1.498.226.588 0 1.086-.092 1.494-.276.409-.183.714-.429.915-.736.2-.308.301-.652.301-1.032 0-.445-.113-.799-.34-1.061a2.1 2.1 0 00-.818-.585 8.9 8.9 0 00-1.226-.368 11.399 11.399 0 01-.862-.246 1.477 1.477 0 01-.522-.294.62.62 0 01-.206-.482c0-.281.12-.507.36-.678.239-.17.604-.255 1.096-.255.3 0 .61.046.929.138.32.091.625.226.92.402l.392-.992a3.292 3.292 0 00-1.025-.452 4.695 4.695 0 00-1.206-.157zm-12.79-.191c-.683 0-1.3.152-1.852.457a3.374 3.374 0 00-1.302 1.262 3.516 3.516 0 00-.474 1.818c0 .674.156 1.28.47 1.817a3.34 3.34 0 001.296 1.263c.551.304 1.17.456 1.853.456a3.85 3.85 0 001.524-.294c.461-.197.85-.482 1.166-.855l-.813-.786c-.49.544-1.093.815-1.81.815-.464 0-.88-.103-1.248-.31a2.212 2.212 0 01-.86-.859 2.5 2.5 0 01-.31-1.247c0-.465.103-.881.31-1.248.206-.367.493-.653.86-.86.368-.206.784-.31 1.249-.31.716 0 1.319.27 1.809.806l.813-.776a3.101 3.101 0 00-1.161-.854 3.814 3.814 0 00-1.52-.295zM20.18 3.25h-1.358v6.882h1.358V3.25zm-13.728 0H3.632v6.882h1.273V8.146H6.45c.594 0 1.11-.098 1.551-.295.44-.196.778-.48 1.013-.85.235-.37.353-.805.353-1.303 0-.505-.118-.94-.353-1.307a2.258 2.258 0 00-1.013-.846c-.44-.197-.957-.295-1.55-.295zM6.3 4.397c.567 0 .997.116 1.29.347.294.23.44.561.44.991 0 .43-.146.76-.44.992-.293.231-.723.347-1.29.347H4.78V4.397H6.3z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E ");
  }
}

.mobile-buttons .btn-checkout {
  display: none;
}

.btn-checkout {
  display: none;
  transition: opacity 0.25s ease;
  outline: none !important;
  position: relative;
  &:hover, &:focus, &:active {
    opacity: 0.7;
  }

  &.desktop {
    top: 0;
    position: absolute;
    right: -40px;

    &.side {
      top: 48px;

      &.large {
        right: -46px;
      }
    }
  }

  &.show {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .counter {
    visibility: hidden;
    position: absolute;
    width: 20px;
    padding-top: 6px;
    padding-right: 1px;
    margin: auto;
    color: var(--covet-pics-close-button-symbol-color);
    font-size: 11px;
    text-align: center;

    &.bounce {
      visibility: visible;
      transition: visibility 0.3s;
      animation: bouncing 1000ms linear both;
    }

    .mobile-buttons & {
      width: 22px;
    }
  }
}

//
// small screens
//
@media only screen and (max-width : 799.98px) {
  .post-image.arrows-mobile-position-top {
    padding-top: 55px
  }

  .btn-checkout.desktop {
    display: none;
  }

  .direct-buy-open .popup-content {
    overflow: hidden;
  }

  .post-video-element {
    margin-bottom: 10px;
    max-height: calc(100vh - 65px);
  } 
}

//
// large screens
//
@media only screen and (min-width : 800px) {
  .post-image {
    width: auto;
    overflow: hidden;
  }

  .popup {
    align-items: center;

    .popup-dialog {
      width: auto;
      max-width: calc(100vw - 100px); // 100% - arrows (2*50px)

      .popup-content {
        flex-direction: row;
      }

      .post-image-element, .post-video-element {
        max-height: calc(720px - 40px); // 40px for swiper dots & arrows
      }
    }

    &.responsive {
      .popup-dialog {
        .post-image {
          max-width: unset;
        }

        .post-image-element, .post-video-element {
          max-width: calc(100vw - 360px - 100px); // 100% - sidebar(360px) - arrows (2*50px)
          max-height: calc(100vh - 20px);
          width: auto;
          height: auto;
        }
      }
    }

    // FIXME: experimental feature
    &.animated-browse {
      .popup-content {
        min-height: 0;
        max-height: 100vh;
        min-width: 0;
        max-width: 100vw;
        transition: all 0.3s linear;
      }
    }
  }
}

@keyframes bouncing {
  0% {
    transform: matrix3d(0.5, 0, 0, 0, 0, 0.5, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  4.7% {
    transform: matrix3d(0.725, 0, 0, 0, 0, 0.725, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  9.41% {
    transform: matrix3d(0.942, 0, 0, 0, 0, 0.942, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  14.11% {
    transform: matrix3d(1.07, 0, 0, 0, 0, 1.07, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  18.72% {
    transform: matrix3d(1.106, 0, 0, 0, 0, 1.106, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  24.32% {
    transform: matrix3d(1.075, 0, 0, 0, 0, 1.075, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  29.93% {
    transform: matrix3d(1.024, 0, 0, 0, 0, 1.024, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  35.54% {
    transform: matrix3d(0.99, 0, 0, 0, 0, 0.99, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  41.04% {
    transform: matrix3d(0.98, 0, 0, 0, 0, 0.98, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  52.15% {
    transform: matrix3d(0.996, 0, 0, 0, 0, 0.996, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  63.26% {
    transform: matrix3d(1.004, 0, 0, 0, 0, 1.004, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  85.49% {
    transform: matrix3d(0.999, 0, 0, 0, 0, 0.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  100% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}

